import { Module } from "@/modules/tenantAdmin/enums";

export default [
  {
    path: "/admin",
    meta: {
      module: Module.Setting,
    },
    children: [
      {
        path: "",
        name: "settings",
        component: () =>
          import("@/modules/tenantAdmin/setting/views/AdminView.vue"),
      },
    ],
  },
];
